module.exports = __webpack_public_path__ + "img/banner_bg.9498e06b.png";